@if (dataSource) {
<mat-grid-list
    cols="2"
    rowHeight="399px"
    gutterSize="16"
>
    <mat-grid-tile>
        <div class="bordered-container no-padding justify-center border-0">
            @if (dataSource) {
            <mat-grid-list
                class="m-w-100"
                cols="1"
                rowHeight="120px"
                gutterSize="19"
            >
                <mat-grid-tile
                    colspan="1"
                    rowspan="1"
                >
                    <div class="bordered-container no-padding justify-center">
                        <div class="wrapper widget-full-width-height-2">
                            @for (item of dataSource.indicatorOptions; track item) {
                            <app-mdr-dashboards-indicator [element]="item"></app-mdr-dashboards-indicator>
                            }
                        </div>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile
                    colspan="1"
                    rowspan="2.4"
                >
                    <div class="bordered-container align-center">
                        <div class="chart-container">
                            <app-mdr-dashboards-area-chart
                                [element]="dataSource.alertTrend"
                                [tooltipWidth]="151"
                                [fillType]="'solid'"
                                [emptyStateTitle]="'No alerts available'"
                                [emptyStateSubtitle]="''"
                                [colors]="dataSource.alertTrend.colors"
                                [strokeCurve]="'straight'"
                                [height]="180"
                                [strokeWidth]="4"
                                [stacked]="false"
                                [chartType]="'line'"
                                [showLegend]="false"
                                [tableLegend]="false"
                                [yaxisLogarithmicScale]="false"
                                [fillOpacity]="0.4"
                                [className]="'alert-trend'"
                            ></app-mdr-dashboards-area-chart>
                        </div>
                    </div>
                </mat-grid-tile>
            </mat-grid-list>
            }
        </div>
    </mat-grid-tile>
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [element]="dataSource.mostMitigatedThreats"
                [mocked]="false"
                [displayedColumns]="dataSource.mostMitigatedThreats.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
</mat-grid-list>
} @if (dataSource) {
<mat-grid-list
    cols="3"
    rowHeight="398"
    class="m-t-16 m-b-25"
    gutterSize="16"
>
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [element]="dataSource.topAlerts"
                [mocked]="false"
                [displayedColumns]="dataSource.topAlerts.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
    <mat-grid-tile
        colspan="2"
        rowspan="1"
    >
        <div class="bordered-container align-center">
            <div class="chart-container">
                <app-mdr-dashboards-area-chart
                    [tooltipWidth]="252"
                    [stacked]="true"
                    [emptyStateTitle]="'No automatic actions were taken.'"
                    [emptyStateSubtitle]="'Enjoy your day!'"
                    [element]="dataSource.automaticActionsTrend"
                    [fillOpacity]="1"
                    [colors]="dataSource.automaticActionsTrend.colors"
                ></app-mdr-dashboards-area-chart>
            </div>
        </div>
    </mat-grid-tile>
</mat-grid-list>
}
